// The 29 ACCESS sub-tracks from the resolver the workflows use; diagnosis-level PHI (SENSITIVE_BOARD_KEYS).
import { ECKM_SUBTRACKS, CKM_SUBTRACKS } from '../../../scripts/access-subtrack-resolver.mjs';

export type SubtrackGroup = 'eckm' | 'ckm';
export interface SubtrackDef { code: string; label: string; group: SubtrackGroup }

// apiv2's value for "this patient has no sub-track yet".
export const SUBTRACK_NONE = 'none';

export const SUBTRACKS: readonly SubtrackDef[] = [
  ...ECKM_SUBTRACKS.map((s) => ({ code: s.subtrack_id, label: s.label, group: 'eckm' as const })),
  ...CKM_SUBTRACKS.map((s) => ({ code: s.subtrack_id, label: s.label, group: 'ckm' as const })),
];

export const SUBTRACK_GROUP_LABELS: Record<SubtrackGroup, string> = { eckm: 'eCKM', ckm: 'CKM' };

const BY_CODE = new Map(SUBTRACKS.map((s) => [s.code, s]));

export function subtrackLabel(code: string | null | undefined): string | null {
  return code ? BY_CODE.get(code)?.label ?? null : null;
}

// What apiv2 accepts in clinical_subtrack (it errors on anything else): the URL check and the menu use it.
export function isSubtrackFilterValue(value: unknown): value is string {
  return typeof value === 'string' && (value === SUBTRACK_NONE || BY_CODE.has(value));
}
